import { useMemo } from 'react'
import { useGetBranchListOnMount } from '@user/store/branches/hooks/useGetBranchListOnMount'
import { useGetSalesTeamListOnMount } from '@user/store/salesTeam/hooks/useGetSalesTeamListOnMount'
import { useGetSalesFunnelListOnMount } from '@user/store/salesFunnel/hooks/useGetSalesFunnelListOnMount'
import { useGetStatesProvinceOnMount } from '../../../hooks/useGetStatesProvinceOnMount'
import { useGetSourcesOnMount } from '@user/store/sources/hooks/useGetSourcesOnMount'
import { useGetCampaignsOnMount } from '@user/store/campaigns/hooks/useGetCampaignsOnMount'
import { useGetTargetPestsOnMount } from '@user/store/targetPests/hooks/useGetTargetPestsOnMount'
import { useGetLocationTypesOnMount } from '@user/store/locationTypes/hooks/useGetLocationTypesOnMount'
import { useGetAllFunnelStagesOnMount } from '@user/store/salesFunnel/hooks/useGetAllFunnelStagesOnMount'
import { useGetServiceFrequenciesOnMount } from '@user/store/serviceFrequency/hooks/useGetServiceFrequenciesOnMount'
import { useGetDivisionsOnMount } from '@user/store/divisions'
import { useGetServicesForTenantOnMount } from '@user/store/serviceProducts/hooks/useGetServicesOnMount'
import { useGetUserListOnMount } from '@user/store/users'
import { useGetCustomFieldsOnMount } from '@user/store/customFields'

export function useData() {
  const branchStatus = useGetBranchListOnMount()
  const salesTeamStatus = useGetSalesTeamListOnMount()
  const salesFunnelStatus = useGetSalesFunnelListOnMount()
  const statesStatus = useGetStatesProvinceOnMount()
  const sourcesStatus = useGetSourcesOnMount()
  const campaignStatus = useGetCampaignsOnMount()
  const targetStatus = useGetTargetPestsOnMount()
  const locationStatus = useGetLocationTypesOnMount()
  const funnelStagesStatus = useGetAllFunnelStagesOnMount()
  const frequenciesStatus = useGetServiceFrequenciesOnMount()

  const divisionStatus = useGetDivisionsOnMount()
  const ownersStatus = useGetUserListOnMount()
  const servicesStatus = useGetServicesForTenantOnMount()
  const serviceFreqStatus = useGetServiceFrequenciesOnMount()

  const cutomFieldsStatus = useGetCustomFieldsOnMount()

  const statuses = useMemo(
    () => [
      branchStatus,
      cutomFieldsStatus,
      salesTeamStatus,
      salesFunnelStatus,
      statesStatus,
      sourcesStatus,
      campaignStatus,
      targetStatus,
      locationStatus,
      funnelStagesStatus,
      frequenciesStatus,
      divisionStatus,
      ownersStatus,
      servicesStatus,
      serviceFreqStatus,
    ],
    [
      branchStatus,
      cutomFieldsStatus,
      salesTeamStatus,
      salesFunnelStatus,
      statesStatus,
      sourcesStatus,
      campaignStatus,
      targetStatus,
      locationStatus,
      funnelStagesStatus,
      frequenciesStatus,
      divisionStatus,
      ownersStatus,
      servicesStatus,
      serviceFreqStatus,
    ],
  )

  const loading = useMemo(
    () => statuses.some((status) => status === 'pending'),
    [statuses],
  )
  const success = useMemo(
    () => statuses.every((status) => status === 'success'),
    [statuses],
  )
  const fail = useMemo(
    () => statuses.some((status) => status === 'fail'),
    [statuses],
  )

  return { loading, success, fail }
}
